import { backendPublicPath } from "@/api/servicePaths";

import FETCHRAW from "../fetchRaw";

export type IndustryEntityType = "account" | "contact" | "product" | "campaign" | "opportunity" | "activity";

export type IndustryAlias = {
  id: string;
  industry: string;
  entity_type: IndustryEntityType;
  field_name: string;
  display_label: string;
  display_label_by_locale?: Record<string, string>;
  description?: string | null;
};

export type IndustryRecordTypeRule = {
  id: string;
  industry: string;
  entity_type: IndustryEntityType;
  record_type_key: string;
  applies_when: Record<string, any>;
  required_fields: string[];
  visible_fields?: string[] | null;
  read_only_fields?: string[] | null;
  enforcement_level: "warn" | "error";
  priority: number;
  is_active: boolean;
  description?: string | null;
};

export const getIndustryTemplates = async () => {
  const res = await FETCHRAW({
    type: "apiurl",
    path: backendPublicPath("/sales/industry-templates/"),
    method: "GET",
    withToken: false
  });

  const sortTemplates = (list: any[]) => {
    return [...list].sort((a, b) => {
      if (a.id === "saas") return -1;
      if (b.id === "saas") return 1;
      const nameA = a.name || a.id || "";
      const nameB = b.name || b.id || "";
      return nameA.localeCompare(nameB);
    });
  };

  if (res?.content && Array.isArray(res.content)) {
    return { ...res, content: sortTemplates(res.content) };
  } else if (Array.isArray(res)) {
    return sortTemplates(res);
  }

  return res;
};

export const applyIndustryTemplate = async (industry_id: string) => {
  return FETCHRAW({
    type: "apiurl",
    path: backendPublicPath("/sales/industry-templates/apply/"),
    method: "POST",
    body: JSON.stringify({ industry_id })
  });
};

export const applyIndustryTemplateWithOverride = async (params: {
  industry_id: string;
  mode?: "merge" | "replace";
  override_patch?: Record<string, any>;
}) => {
  return FETCHRAW({
    type: "apiurl",
    path: backendPublicPath("/sales/industry-templates/apply/"),
    method: "POST",
    body: JSON.stringify(params)
  });
};
